import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { APP_ROUTES } from '../../util/routes/appRoutes';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard  {

	constructor(private auth: AuthService, private router: Router) { }

	canActivate() {
		const isAuthenticated: boolean = this.auth.isAuthenticated();
		if (!isAuthenticated) {
			this.router.navigate([APP_ROUTES.root]).then(() => {
                // To perform some async task
            });
		}
		return true;
	}
}